<template>
	<div class="content">
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span class="size">油品订单退款</span>
			</div>
			<el-table :data="offlineList" border style="width: 100%">
				<el-table-column prop="ordersn" label="订单编号" align="center"> </el-table-column>
				<el-table-column prop="user" label="用户名">
					<template slot-scope="scope">
						<span>{{ scope.row.user.username }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="user" label="手机号">
					<template slot-scope="scope">
						<span>{{ scope.row.user.mobile }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="goods" label="油品">
					<template slot-scope="scope">
						<span>{{ scope.row.goods.name }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="refund_desc" label="退款原因"></el-table-column>
				<el-table-column
					prop="refund_fail_reason"
					label="退款失败原因"
				></el-table-column>
				<el-table-column prop="refund_money" label="退款金额"></el-table-column>
				<!-- <el-table-column prop="address" label="支付状态"></el-table-column> -->
				<el-table-column prop="refund_status" label="退款状态">
					<template slot-scope="scope">
						<span
							v-text="
								scope.row.refund_status == 0
									? '未退款'
									: scope.row.refund_status == 1
									? '退款中'
									: scope.row.refund_status == 2
									? '退款完成'
									: '退款失败'
							"
						></span>
					</template>
				</el-table-column>
				<el-table-column prop="emp" label="员工">
					<template slot-scope="scope">
						<span v-if="scope.row.emp !== null">{{ scope.row.emp.name }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="refund_operator" label="操作人">
					<template slot-scope="scope">
						<span>{{ scope.row.refund_operator.mobile }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="apply_refund_time" label="申请时间">
					<template slot-scope="scope">
						<span>{{ scope.row.apply_refund_time | dataFormat }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="refund_time" label="退款时间">
					<template slot-scope="scope">
						<span>{{ scope.row.refund_time | dataFormat }}</span>
					</template>
				</el-table-column>
			</el-table>
			<br />
			<el-pagination
				background
				layout="prev, pager, next"
				:current-page="offlinepage"
				:total="offlineTotal"
				:page-size="5"
				@current-change="offlineChange"
			>
			</el-pagination>
		</el-card>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span class="size">充值订单退款</span>
			</div>
			<el-table :data="rechargeList" border style="width: 100%">
				<el-table-column prop="ordersn" label="订单编号" align="center"> </el-table-column>
				<el-table-column prop="user" label="用户名">
					<template slot-scope="scope">
						<span>{{ scope.row.user.username }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="user" label="手机号">
					<template slot-scope="scope">
						<span>{{ scope.row.user.mobile }}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="goods" label="油品">
					<template slot-scope="scope">
						<span>{{ scope.row.goods.name }}</span>
					</template>
				</el-table-column> -->
				<el-table-column prop="refund_desc" label="退款原因"></el-table-column>
				<el-table-column
					prop="refund_fail_reason"
					label="退款失败原因"
				></el-table-column>
				<el-table-column prop="refund_money" label="退款金额"></el-table-column>
				<!-- <el-table-column prop="address" label="支付状态"></el-table-column> -->
				<el-table-column prop="refund_status" label="退款状态">
					<template slot-scope="scope">
						<span
							v-text="
								scope.row.refund_status == 0
									? '未退款'
									: scope.row.refund_status == 1
									? '退款中'
									: scope.row.refund_status == 2
									? '退款完成'
									: '退款失败'
							"
						></span>
					</template>
				</el-table-column>
				<el-table-column prop="emp" label="员工">
					<template slot-scope="scope">
						<span v-if="scope.row.emp !== null">{{ scope.row.emp.name }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="refund_operator" label="操作人">
					<template slot-scope="scope">
						<span>{{ scope.row.refund_operator.mobile }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="apply_refund_time" label="申请时间">
					<template slot-scope="scope">
						<span>{{ scope.row.apply_refund_time | dataFormat }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="refund_time" label="退款时间">
					<template slot-scope="scope">
						<span>{{ scope.row.refund_time | dataFormat }}</span>
					</template>
				</el-table-column>
			</el-table>
			<br />
			<el-pagination
				background
				layout="prev, pager, next"
				:current-page="rechargepage"
				:total="rechargeTotal"
				:page-size="5"
				@current-change="rechargeChange"
			>
			</el-pagination>
		</el-card>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span class="size">普通订单退款</span>
			</div>
			<el-table :data="normalOrderList" border style="width: 100%">
				<el-table-column prop="ordersn" label="订单编号"> </el-table-column>
				<el-table-column prop="user" label="用户名">
					<template slot-scope="scope">
						<span>{{ scope.row.user.username }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="user" label="手机号">
					<template slot-scope="scope">
						<span>{{ scope.row.user.mobile }}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="goods" label="油品">
					<template slot-scope="scope">
						<span>{{ scope.row.goods.name }}</span>
					</template>
				</el-table-column> -->
				<el-table-column prop="refund_desc" label="退款原因"></el-table-column>
				<el-table-column
					prop="refund_fail_reason"
					label="退款失败原因"
				></el-table-column>
				<el-table-column prop="refund_money" label="退款金额"></el-table-column>
				<!-- <el-table-column prop="address" label="支付状态"></el-table-column> -->
				<el-table-column prop="refund_status" label="退款状态">
					<template slot-scope="scope">
						<span
							v-text="
								scope.row.refund_status == 0
									? '未退款'
									: scope.row.refund_status == 1
									? '退款中'
									: scope.row.refund_status == 2
									? '退款完成'
									: '退款失败'
							"
						></span>
					</template>
				</el-table-column>
				<el-table-column prop="emp" label="员工">
					<template slot-scope="scope">
						<span v-if="scope.row.emp !== null">{{ scope.row.emp.name }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="refund_operator" label="操作人">
					<template slot-scope="scope">
						<span>{{ scope.row.refund_operator.mobile }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="apply_refund_time" label="申请时间">
					<template slot-scope="scope">
						<span>{{ scope.row.apply_refund_time | dataFormat }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="refund_time" label="退款时间">
					<template slot-scope="scope">
						<span>{{ scope.row.refund_time | dataFormat }}</span>
					</template>
				</el-table-column>
			</el-table>
			<br />
			<el-pagination
				background
				layout="prev, pager, next"
				:current-page="normalOrderpage"
				:total="normalOrderTotal"
				:page-size="5"
				@current-change="normalOrderChange"
			>
			</el-pagination>
		</el-card>
	</div>
</template>
<script>
import { normalOrder_refundList, offline_refundList, recharge_refundList } from "@/api/vip";
import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	data() {
		return {
			offlineList: [],
			rechargeList: [],
			normalOrderList: [],
			offlinepage: 1,
			rechargepage: 1,
			normalOrderpage: 1,
			offlineTotal: 0,
			rechargeTotal: 0,
			normalOrderTotal: 0,
		};
	},
	mounted() {
		this.getOffline_refundList();
		this.getRecharge_refundList();
		this.getNormalOrder_refundList();
	},
	methods: {
		async getOffline_refundList() {
			try {
				let data = {
					page: this.offlinepage,
					app_id: this.app_id,
					refund: 1,
					limit: 5,
				};
				const res = await offline_refundList(data);
				if (res.code == 200) {
					this.offlineList = res.data;
					this.offlineTotal = res.total;
				}
			} catch (e) {
				console.log(e);
			}
		},
		async getRecharge_refundList() {
			try {
				let data = {
					page: this.rechargepage,
					app_id: this.app_id,
					refund: 1,
					limit: 5,
				};
				const res = await recharge_refundList(data);
				if (res.code == 200) {
					this.rechargeList = res.data;
					this.rechargeTotal = res.total;
				}
			} catch (e) {
				console.log(e);
			}
		},
		async getNormalOrder_refundList() {
			try {
				let data = {
					page: this.normalOrderpage,
					app_id: this.app_id,
					refund: 1,
					limit: 5,
				};
				const res = await normalOrder_refundList(data);
				if (res.code == 200) {
					this.normalOrderList = res.data;
					this.normalOrderTotal = res.total;
				}
			} catch (e) {
				console.log(e);
			}
		},
		offlineChange(p) {
			this.offlinepage = p;
			this.getOffline_refundList();
		},
		rechargeChange(p) {
			this.rechargepage = p;
			this.getRecharge_refundList();
		},
		normalOrderChange(p) {
			this.normalOrderpage = p;
			this.getNormalOrder_refundList();
		},
	},
};
</script>
<style scoped>
.content {
	padding: 10px 15px;
	height: 100%;
	background: #f1f2f6;
	overflow: auto;
}
.clearfix:before,
.clearfix:after {
	display: table;
	content: "";
}
.clearfix:after {
	clear: both;
}

.box-card {
	/* min-width: 100px; */
	width: 95%;
	margin: 20px;
	/* min-width: 100px; */
}
.size {
  font-size: 18px;
}
</style>
